import * as React from 'react';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';

import { BedroomFilter as BedroomFilterInput } from '../../components/search_filters/filters/bedroom_filter';
import { GenericFilter } from './generic_filter';

import { setBedroom, setDirty } from '../../redux/modules/search/bedroom';

import { IBedroom } from '../../models/filters/bedroom';

interface IProps {
  bedroom: IBedroom;
  dispatch: Dispatch<any>;
}

class BedroomFilter extends GenericFilter<IProps> {
  protected setDirty(isDirty: boolean) {
    this.props.dispatch(setDirty(isDirty));
  }

  public render() {
    return (
      <BedroomFilterInput
        value={this.props.bedroom.bedroom}
        onChange={(bedroom: string) => this.props.dispatch(setBedroom(bedroom))}
      />
    );
  }
}

const BedroomFilterWrapper = connect((state: { bedroom: IBedroom }) => ({
  bedroom: state.bedroom,
}))(BedroomFilter as any);

export { BedroomFilterWrapper as BedroomFilter, BedroomFilter as BedroomFilterClass };
